import React from 'react';

import Export from 'components/Explorer/Export';
import NumberHelper from 'util/number_helper';
import SummaryBlock from 'components/Explorer/ContentPanel/SummaryBlock';
import SaveSearch from 'components/Explorer/SaveSearch';
import helpFor from 'util/help.js';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = () => {
  const params = useQueryParams();
  const { data, loading, status } = useExplorerData('mention_sources/summary', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;
  const forbidden = status === 403;

  const total = data?.total ?? 0;
  const totalMentions = data?.total_mentions ?? 0;

  const summarySentence = () => {
    if (loadingFailed) {
      return <div>{forbidden ? '' : I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div>
        {I18n.htmlSafe('Explorer.MentionSources.Summary.mention_sources_html', {
          count: total,
          formattedCount: NumberHelper.formatNumberWithDelimiter(total)
        })}{' '}
        {I18n.htmlSafe('Explorer.MentionSources.Summary.mentions_html', {
          count: totalMentions,
          formattedCount: NumberHelper.formatNumberWithDelimiter(totalMentions)
        })}
      </div>
    );
  };

  return (
    <SummaryBlock hasWarning={loading === Loading.SUCCESS && totalMentions === 0}>
      {isLoading ? (
        I18n.t('Explorer.MentionSources.Summary.loading')
      ) : (
        <>
          <div>{summarySentence()}</div>
          <Export endpoint="mention_sources" help={helpFor('mention_sources')} />
          <SaveSearch endpoint="mention_sources" analyticsName="Mention Sources" />
        </>
      )}
    </SummaryBlock>
  );
};

export default Summary;
